<script>
import { dictItem } from "_api/sysTem/index";
import request from "@/axios/index";

export default {
  name: 'BatchFileDownload',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      fileDicId: '',
      formId: null,
      ids: [],
      fileList: [],
      selectedFiles: [],
      downloadLoading: false
    }
  },
  watch: {
    modelValue(val) {
      this.dialogVisible = val
    }
  },
  computed: {
    filteredList() {
      return this.fileList
    }
  },
  methods: {
    async open(fileDicId, formId, ids) {
      this.fileDicId = fileDicId
      this.formId = formId
      this.ids = ids || []
      console.error('this.formId', ids)
      await this.loadFileList()
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    async loadFileList() {
      console.error('this.fileDicId', this.fileDicId)
      if (!this.fileDicId) return
      try {
        const res = await dictItem({ 
          method: "get", 
          reqInfo: { 
            dicId: this.fileDicId, 
            pageNum: 1, 
            pageSize: 9999999 
          } 
        })
        this.fileList = res?.result?.map(item => ({
          ...item,
          id: item.itemValue,
          fileType: item.englishName  || item.itemValue,
        })) || []
      } catch (error) {
        console.error('加载文件列表失败:', error)
        this.fileList = []
      }
    },
    indexMethod(index) {
      return index + 1
    },
    handleSelectionChange(selection) {
      this.selectedFiles = selection
    },
    async handleDownload() {
      if (this.selectedFiles.length === 0) {
        this.$message.warning('请选择要下载的文件')
        return
      }

      const fileTypeCount = {}
      this.selectedFiles.forEach(file => {
        const type = file.itemValue || file.fileType
        fileTypeCount[type] = (fileTypeCount[type] || 0) + 1
      })

      for (const type in fileTypeCount) {
        if (fileTypeCount[type] < 1) {
          this.$message.warning('每种文件类型必须至少选中一个')
          return
        }
      }

      this.downloadLoading = true
      try {
        const types = Object.keys(fileTypeCount).join(',')
        const idsParam = this.ids.join(',')
        
        const response = await request({
          method: 'post',
          url: '/common/zip-file',
          params: {
            formId: this.formId && Array.isArray(this.formId) ? this.formId[0] : this.formId,
            types: types,
            ids: idsParam
          },
          responseType: 'blob'
        })

        const blob = new Blob([response.data], { type: 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `files_${new Date().getTime()}.zip`
        link.click()
        window.URL.revokeObjectURL(url)

        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败')
      } finally {
        this.downloadLoading = false
      }
    }
  }
}
</script>

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="批量文件下载"
    width="600px"
    :before-close="handleClose"
  >
    <el-table
      :data="filteredList"
      border
      stripe
      height="300px"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
      />
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod"
        align="center"
      />
      <el-table-column
        prop="fileType"
        label="文件类型"
        align="center"
      />
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="handleDownload" :loading="downloadLoading">下载选中文件</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss">
</style>
